// Variants like success, error etc
export const TOASTS_VARIANTS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
};

// Predefined templates like common, preloader etc
export const TOASTS_TEMPLATES = {
  COMMON: 'common',
  PRELOADER: 'preloader',
};
